import { useAuth0 } from "@auth0/auth0-react";
import config from "environment";
import { useDispatch } from "react-redux";
import {
  setUser,
  setSignUpNow,
} from "../../redux/features/appData/appDataSlice";
import { deleteState, setExtensionLogoutFlag } from "../../utils/localStorage";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import "./Logout.css";
import { useNavigate } from "react-router-dom";
const returnURL = config.redirect.replace("signup", "login");

// this is whete the authenticator sends the user once they auth
// there are some states they can be in
// email is valid, route them to the app
// email is not in our DB, do they want to sign in with a different one or sign up
export default function Logout() {
  const source = new URLSearchParams(window.location.search).get("source");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { logout } = useAuth0();

  useEffect(() => {
    // clean up redux store
    dispatch(setUser(null));
    // clean up session storage
    dispatch(setSignUpNow(false));
    deleteState();

    setTimeout(() => {
      navigate("/login");
    }, 1500);

    // setTimeout(() => {
    //   // clean up redux store
    //   dispatch(setUser(null));
    //   // clean up session storage
    //   dispatch(setSignUpNow(false));

    //   deleteState();

    //   // NR2 - removed this until we do Auth0 again
    //   // logout({ logoutParams: { returnTo: returnURL } });
    // }, 500);
  }, []);

  return (
    <>
      <div id="logout-page" className={config.theme}>
        <div className="logout-page-body">
          <div className="logout-page-text">We're logging you out...</div>
            <CircularProgress />
        </div>
      </div>
    </>
  );
}
